// extracted by css-extract-rspack-plugin
var _1 = "Af2qFn5mOzE1F51n";
var _2 = "OZbi8D_2XiI3uM3G";
var _3 = "joygAHDz6QcMFgFA";
var _4 = "C42iMZI4VKgMrkpC";
var _5 = "Bv6isM7q6w10ZKvW";
export { _1 as "header", _2 as "heading", _3 as "linkButtons", _4 as "mainHeader", _5 as "root" }
